<template>
  <div class="index-page">
    <div class="index-container">
<!--      <div class="login-content" v-if="!hasLogin">-->
<!--        <div class="login-box">-->
<!--          <div class="login-form">-->
<!--            <div class="login-label"> 密码：</div>-->
<!--            <input v-model="passWord" class="login-input" />-->
<!--          </div>-->
<!--          <div class="login-btn" @click="handleLogin">登录</div>-->
<!--        </div>-->
<!--      </div>-->
      <div class="index-content" v-if="hasLogin" @click="goPano">
        <div class="index-title"></div>
        <!-- <div class="index-logo"></div> -->
        <div class="index-btn" @click="goPano"></div>
        <div class="index-text"></div>
      </div>

    </div>
    <div class="landscape-tip-box" v-if="landscape">
      <div class="landscape-tip"></div>
    </div>
  </div>
</template>
<script>
  export default {
    data() {
      return {
        hasLogin: true,
        rightPass: "0927",
        passWord: "",
        landscape: false,
      };
    },
    methods: {
      goPano() {
        this.$router.push({
          path: "/panoPage",
        });
          window.goldlog.record("/spec.1.1", "", "snsScene=首页&product=phoneweb&pagename=云上2023年中国品牌博览会", "")
      },
      handleLogin() {
        if (this.passWord) {
          if (this.passWord == this.rightPass) {
            this.hasLogin = true
          } else {
            this.$message.error("您输入的密码不正确");
          }
        } else {
          this.$message.error("请输入密码！");
        }
      },
      origentChange() {
        var orientation = window.orientation;

        switch (orientation) {
          case 90:

          case -90:
            orientation = "landscape"; //这里是横屏
            this.landscape = true;
            break;

          default:
            orientation = "portrait"; //这里是竖屏
            this.landscape = false;
            break;
        }
      },
    },
    mounted() {
      var that = this
      that.origentChange();

      window.addEventListener(
              "orientationchange",
              function () {
                that.origentChange();
              },
              false
      );
    },
  };
</script>
<style lang="scss" scoped>
  @mixin background-com {
    background-repeat: no-repeat;
    background-size: 100% 100%;
  }
  .index-page {
    width: 100%;
    height: 100%;
    background-color: #ffffff;

    .index-container {
      width: 100%;
      height: 100%;
      background-image: url("../../../assets/img/phone/index-bg.png");
      background-repeat: no-repeat;
      background-size: 100% 100%;
      position: relative;

      .index-title {
        width: 9.46rem;
        height: 8.40rem;
        background-image: url("../../../assets/img/phone/index-title.png");
        background-repeat: no-repeat;
        background-size: cover;
        position: absolute;
        top: 1.0rem;
        left: 50%;
        margin-left: -5.0rem;
      }

      // .index-logo{
      //     width: 3.91rem;
      //    height: 1.14rem;
      //    background-image: url("../../../assets/img/phone/index-logo.png");
      //    background-repeat: no-repeat;
      //    background-size: 100% 100%;
      //    position: absolute;
      //    top: 7.25rem;
      //    left: 50%;
      //    margin-left: -1.955rem;
      // }
      .index-btn {
        width: 3.17rem;
        height: 1.15rem;
        background-image: url("../../../assets/img/phone/index-btn.png");
        background-repeat: no-repeat;
        background-size: 100% 100%;
        position: absolute;
        top: 12rem;
        left: 50%;
        margin-left: -1.45rem;
      }

      .index-text {
        width: 10.80rem;
        height: 4.41rem;
        background-image: url("../../../assets/img/phone/index-text.png");
        background-repeat: no-repeat;
        background-size: 100% 100%;
        position: absolute;
        bottom: 0;
        left: 50%;
        margin-left: -5.4rem;
      }
    }

    .login-content {
      width: 100%;
      height: 100%;
      position: absolute;
      top: 0;
      left: 0;
      z-index: 1000;
      background-color: #C6060F;

      .login-box {
        width: 8rem;
        height: 3rem;
        position: absolute;
        top: 50%;
        left: 50%;
        margin-top: -1.5rem;
        margin-left: -4rem;

        .login-form {
          width: 100%;
          display: flex;
          align-items: center;
          color: #fff;
          font-size: 0.48rem;
          margin-bottom: 0.8rem;
        }

        .login-btn {
          width: 4rem;
          height: 1.2rem;
          line-height: 1.2rem;
          border-radius:0.1rem;
          background-color: #DF8903;
          margin-left: 0.2rem;
          color: #fff;
          font-size: 0.48rem;
          cursor: pointer;
          margin: 0 auto;
        }

        .login-label {
          width: 2rem;
          line-height: 0.6rem;
        }
        .login-input{
          flex: 1;
          height: 0.8rem;
          font-size: 0.48rem;
        }
      }
    }

    .landscape-tip-box {
      width: 100%;
      height: 100%;
      background-color: #000000;
      position: absolute;
      top: 0;
      left: 0;
      z-index: 1000000000;

      .landscape-tip {
        width: 2.56rem;
        height: 3rem;
        background-image: url("../../../assets/img/landscape-tip.png");
        @include background-com();
        position: absolute;
        top: 50%;
        margin-top: -1.5rem;
        left: 50%;
        margin-left: -1.28rem;
      }
    }
  }
</style>